import { render, staticRenderFns } from "./ActivityArea.vue?vue&type=template&id=7e207410&scoped=true&"
import script from "./ActivityArea.vue?vue&type=script&lang=js&"
export * from "./ActivityArea.vue?vue&type=script&lang=js&"
import style0 from "./ActivityArea.vue?vue&type=style&index=0&id=7e207410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e207410",
  null
  
)

export default component.exports